'use strict';
module.exports = function GoldFilePicker(navigatorShim) {
	let currentPromise;
	const fileInputField = navigatorShim.createElement('input'),
		readFile = function (file) {
			if (file) {
				return navigatorShim.readFileAsDataURL(file);
			} else {
				return Promise.reject('cancel');
			}
		},
		onFileChosen = function () {
			const activePromise = currentPromise,
				file = fileInputField.files && fileInputField.files[0];
			currentPromise = undefined;
			readFile(file)
				.then((contents) => {
					return { contents: contents, type: file.type, name: file.name };
				})
				.then(activePromise.resolve, activePromise.reject);
		},
		constructPromise = function () {
			const result = {};
			result.promise = new Promise((resolve, reject) => {
				result.resolve = resolve;
				result.reject = reject;
			});
			return result;
		},
		pickFile = function (extensionTypes) {
			if (currentPromise) {
				currentPromise.reject('cancel');
			}
			currentPromise = constructPromise();
			fileInputField.value = '';
			if (extensionTypes) {
				fileInputField.setAttribute('accept', extensionTypes);
			} else {
				fileInputField.removeAttribute('accept');
			}
			fileInputField.click();
			return currentPromise.promise;
		};
	fileInputField.setAttribute('type', 'file');
	fileInputField.addEventListener('change', onFileChosen);
	Object.freeze(Object.assign(this, {pickFile}));
};

